export const MEDIA_MAXIMUM_FILES_SIZE = 2_000_000_000;

export const MEDIA_ACCEPT_BY_CLASS = {
  Audio: ".mp3,.wav,.ogg,.flac,.aac,audio/*",
  Video: ".mp4,.webm,.ogg,video/mp4,video/webm,video/ogg,application/ogg",
};

export const MEDIA_CLASSES = [
  { id: "Audio", name: "Audio" },
  { id: "Video", name: "Video" },
  { id: "Texto", name: "Texto" },
];
